// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.5548 6.87928L17.3278 0.652344L3.97906 14.0011L3.41366 16.8281L7.37901 20.7935L10.206 20.2281L23.5548 6.87928ZM1.38574 19.6129L4.59423 22.8214L6.00844 21.4072L2.79996 18.1987L1.38574 19.6129Z"}}]};

const PenMarkFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-mark-filled',
    ref,
    icon: element,
  },
));

PenMarkFilledIcon.displayName = 'PenMarkFilledIcon';

export default PenMarkFilledIcon;
